// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608061431/js/" + chunkId + "." + {"44":"3ebf0b43","225":"b655c61d","481":"bfef0e5b","486":"97c3e68e","770":"859c91e0"}[chunkId] + ".0.6553904748323874.chunk.js";
};